import React, { memo } from 'react';

import { Container } from '~/Components/Grid/Grid';
import StatisticsHeader from '~/Components/StatisticsHeader/StatisticsHeader';
import { getStatisticsHeaderData } from '~/utils/statistics';

import styles from './ProfileStatisticsHeader.scss';

export interface ProfileStatisticsHeaderProps {
  statistics: BattleStat;
  seasonsAndBestRanksData?: SeasonBestRankInfo[];
  seasonsAndBestRatingData?: SeasonBestRatingInfo[];
  seasonNumber?: string | number;
}

const ProfileStatisticsHeader = (props: ProfileStatisticsHeaderProps) => {
  const statisticsHeaderData = getStatisticsHeaderData(
    props.statistics,
    props.seasonsAndBestRanksData,
    props.seasonsAndBestRatingData,
    props.seasonNumber,
  );

  return (
    <Container className={styles.wrapper}>
      <StatisticsHeader
        data={statisticsHeaderData}
        withBestRank={!!props.seasonsAndBestRanksData}
        withBestRating={!!props.seasonsAndBestRatingData}
      />
    </Container>
  );
};

export default memo(ProfileStatisticsHeader);
